import React, { useContext, useEffect, useState } from "react";
import { Modal } from "flowbite-react";
import Result from "../result/Result";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import axios from "axios";
import { useParams } from "react-router-dom";
import Dashboard from "../../Dashboard";
import Analyzedpdf from "./analyzedpdf";
import { tableDataContext } from "../../context/productData";
import "./uploaddoc.scss";
import AddBrouchureModal from "./AddBrouchureModal";

function DashboardMain() {
  const [show, setShow] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [loaderModal, setLoaderModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [dbdatapdf, setDbdatapdf] = useState([]);
  const [ven_name, setVen_name] = useState("");

  const [date, setDate] = useState("");

  const [selectedFileName, setSelectedFileName] = useState("");
  const {
    pdfData,
    setPdfData,
    setResponseDatapdf,
    responseDatapdf,
    setAllResponse,
  } = useContext(tableDataContext);
  const { id } = useParams();
  const [error, setError] = useState({});

  useEffect(() => {
    console.log("responseDatapdf", responseDatapdf);
    if (responseDatapdf.length > 0) {
      console.log(responseDatapdf);
      setShow(true);
      setLoader(true);
    }
    if (pdfData) {
      if (pdfData.pdfData) {
        setResponseDatapdf(pdfData.pdfData);
        console.log("context value", pdfData.pdfData);
        setLoader(false);
      }
      if (pdfData.dbPdfData) {
        setDbdatapdf(pdfData.dbPdfData);
        console.log("context value", pdfData.dbPdfData);
        setLoader(false);
      }
      console.log(pdfData);
      setVen_name(pdfData.venName);
      setShow(true);
    }
  }, [responseDatapdf, pdfData]);

  const handleUploadpdf = async () => {
    setAllResponse("");
    setPdfData("");
    setResponseDatapdf("");
    setDbdatapdf("");
    setOpenModal(false);
    setLoaderModal(true);
    setLoader(true);
    const formData = new FormData();
    formData.append("file", selectedFileName);
    formData.append("vendor_name", ven_name);
    formData.append("user_id", id);
    axios
      .post("https://aipricingtool-python.onrender.com/upload", formData)
      .then((response) => {
        localStorage.setItem("pdf_name", selectedFileName.name);
        localStorage.setItem("venName", ven_name);
        console.log("response", response);
        if (response.data.images) {
          axios
            .post("https://aipricingtool-python.onrender.com/gemini", {
              vendor_name: ven_name,
              pdf_name: response.data.pdf_name,
              user_identifier: id,
              socket_id: id,
            })
            .then((res) => {
              setPdfData({ pdfData: res.data, venName: ven_name });
              setResponseDatapdf("");
              setLoader(false);
            })
            .catch((err) => {
              console.log(err);
              setLoader(false);
              setLoaderModal(false);
              toast.error("Error Uploading Data");
            });
        } else {
          console.log(response.data);
          const outputs = response.data.map((item) => item.output.output);
          console.log(outputs);
          setDbdatapdf(outputs);
          setPdfData({ dbPdfData: outputs, venName: ven_name });
          setShow(true);
          setLoaderModal(false);
          setLoader(false);
        }
        if (response.data.success) {
          setLoaderModal(false);
          setShow(true);
        }
        toast.success("Upload successful");
      })
      .catch((error) => {
        console.error("API Error:", error);
        toast.error(error);
        setLoader(false);
        setLoaderModal(false);
      });
  };

  return (
    <Dashboard>
      <div>
        {show ? (
          <>
            <Result
              dbdatapdf={dbdatapdf}
              responseDatapdf={responseDatapdf}
              setResponsedatapdf={setResponseDatapdf}
              setShow={setShow}
              setLoader={setLoader}
              loader={loader}
              setOpenModal={setOpenModal}
              ven_name={ven_name}
              setVen_name={setVen_name}
              date={date}
              setDate={setDate}
              setSelectedFileName={setSelectedFileName}
              selectedFileName={selectedFileName}
              setLoaderModal={setLoaderModal}
            />
          </>
        ) : (
          <>
            <div className="w-full flex  justify-end">
              <div className=" mobilescreen w-full  px-5 md:px-0 custom_height flex justify-end  items-center gap-x-4  sm:gap-x-12  md:gap-x-24  2xl:gap-x-48">
                <div
                  className="upload dashboard_main   duration-500 flex items-center gap-2 w-full md:w-auto px-0 md:px-20 cursor-pointer py-7 md:py-10 justify-center border-2 border-dashed rounded-3xl  "
                  onClick={() => {
                    setVen_name("");
                    setSelectedFileName("");
                    setOpenModal(true);
                  }}
                >
                  <div className="img w-9 ml-5">
                    <Icon
                      icon="gg:add"
                      width="26"
                      height="26"
                      color="#d76e3e"
                    />
                  </div>

                  <span className=" text-xl md:text-3xl font-semibold mr-5 primary">
                    Upload Document
                  </span>
                </div>
                <div className="  w-full sm:w-1/3 ">
                  <Analyzedpdf
                    hide="d-none"
                    heading="History of Analysed PDFs"
                    setVen_name={setVen_name}
                    setDbdatapdf={setDbdatapdf}
                    dbdatapdf={dbdatapdf}
                    setShow={setShow}
                  />
                </div>
              </div>
            </div>

            <AddBrouchureModal
              openModal={openModal}
              setOpenModal={setOpenModal}
              selectedFileName={selectedFileName}
              setSelectedFileName={setSelectedFileName}
              ven_name={ven_name}
              setVen_name={setVen_name}
              date={date}
              setDate={setDate}
              error={error}
              setError={setError}
              handleUploadpdf={handleUploadpdf}
            />

            {/* Loader modal */}
            <Modal
              show={loaderModal}
              size="md"
              className="dashboard-modal-main ring-0 bg-opacity-60"
              // onClose={() => setOpenModal(false)}
              popup
            >
              {/* <Modal.Header /> */}
              <Modal.Body className="bg-white rounded-[25px] p-5 ">
                <div className="text-center flex justify-center items-center flex-col gap-3">
                  {loader ? (
                    <>
                      <div className="spinner"></div>
                      <h3 className="analyzing mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                        Analyzing Document...
                      </h3>
                    </>
                  ) : (
                    <></>
                  )}

                  {/* <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" /> */}
                </div>
              </Modal.Body>
            </Modal>
          </>
        )}
      </div>
    </Dashboard>
  );
}

export default DashboardMain;
